module.exports = __webpack_public_path__ + "static/img/banner.2654802.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/banner.png
// module id = l/wZ
// module chunks = 74